import CaseNotesHistory from "./CaseNotesHistory.container";

export default CaseNotesHistory;
